import { API } from "./api";
import { z } from "zod"
import { Area, areaSchema, convertArea, convertAreaSchema } from "./area";
import { JSONBody } from "./general";

export interface Scanner {
  id: number;
  name: string;
  areas: Area[];
}

export const convertScanner = (s: API.Scanner): Scanner => {
  return {
    id: s.id,
    name: s.name,
    areas: s.areas?.map(convertArea) ?? [],
  };
};

export const convertScanners = (s: API.Scanner[]): Scanner[] => {
  return s.map(convertScanner).sort((a, b) => a.name > b.name ? 1 : -1);
};

// Schema

export const convertScannerSchema = (s: Scanner): ScannerSchema => {
  return {
    id: s.id,
    name: s.name,
    areas: s.areas.map(convertAreaSchema),
  }
}

export const scannerSchema = z.object({
  id: z.number().optional(),
  name: z.string().nonempty(),
  areas: z.array(areaSchema),
})
export type ScannerSchema = z.infer<typeof scannerSchema> & JSONBody;
